// @ts-check

/**
 * Bento Intelligence — one-shot scroll-into-view reveal.
 *
 * The project rows start uniform (same 81% width, full opacity) and settle
 * into their true widths/opacities the first time the stack scrolls into
 * view, while the feature card blooms open. All timing/easing lives in CSS;
 * this only toggles `is-armed` (start state) and `is-revealed` (settle),
 * once. Reduced-motion or missing IntersectionObserver leaves the true state.
 */

(function() {
    'use strict';

    const stacks = /** @type {HTMLElement[]} */ (Array.from(
        document.querySelectorAll('.bento__intel-stack'),
    ));
    if (!stacks.length) {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    // Switch to the uniform start state before the stack is seen.
    for (let i = 0; i < stacks.length; i++) {
        stacks[i].classList.add('is-armed');
    }

    if (typeof IntersectionObserver === 'undefined') {
        for (let i = 0; i < stacks.length; i++) {
            stacks[i].classList.add('is-revealed');
        }
        return;
    }

    const io = new IntersectionObserver((entries, obs) => {
        for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];
            if (entry.isIntersecting) {
                entry.target.classList.add('is-revealed');
                obs.unobserve(entry.target);
            }
        }
    }, {threshold: 0.35});

    for (let i = 0; i < stacks.length; i++) {
        io.observe(stacks[i]);
    }
})();
